// Service Worker registration handler
// Vite PWA will auto-generate the service worker, this file handles registration logic

export async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      // The actual SW will be generated by Vite PWA at /sw.js
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      })

      console.log('✅ Service Worker registered:', registration)

      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('🔄 Service Worker updated to new version')
              // Notify user of app update if needed
              window.dispatchEvent(new Event('sw-update'))
            }
          })
        }
      })
    } catch (error) {
      console.warn('⚠️ Service Worker registration failed:', error)
      // Don't fail the app if SW registration fails
    }
  }
}
